import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { useGetUserInformation } from "../../features/users";
import { getImage } from "../../utils/utils";

const BusninessMobileNavbarItems = ({ sidebaritems, type }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: user } = useGetUserInformation();
  const userFirstName = user?.first_name_fa || "";
  const userLastName = user?.last_name_fa || "";
  const business = useSelector((store) => store.bussinessSlice?.data.business || "");

  const [activeMenu, setActiveMenu] = useState(null);
  //console.log({activeMenu})
  const [selectedSubMenu, setSelectedSubMenu] = useState(null);

  useEffect(() => {
    setActiveMenu(null);
    sidebaritems.forEach((nav) => {
      if (location.pathname.startsWith(nav.path)) {
        setActiveMenu(nav.id);
        nav.subNav.forEach((sub) => {
          const fullPath = nav.path + sub.path;
          if (location.pathname === fullPath) {
            setSelectedSubMenu(fullPath);
          }
        });
      }
    });
  }, [location.pathname, sidebaritems]);

  const menuClickHandler = (index, nav) => {
    setActiveMenu(index);
    if (!nav.subNav.length) {
      navigate(nav.path);
      setSelectedSubMenu(nav.path);
    } else {
      const fullPath = nav.path + nav.subNav[0].path;
      navigate(fullPath);
      setSelectedSubMenu(fullPath);
    }
  };

  return (
    <div className="min-w-[240px] h-full text-title-sm-regular     ">
      {type === "business" && (
        // <Link to={`bussiness/detail`} className=" text-title-md-semibold " >
        <div className="flex-between">
          <Link className=" text-title-md-semibold max-w-[200px] truncate flex gap-2 items-center ">
            <img
              className="p-1 rounded-v-lg w-10 h-10"
              src={business.logo ? getImage(business.logo) : "/images/briefcase.svg "}
              alt="check"
            />
            {business?.fa_name}
          </Link>
          <button
            className="bg-dark text-white p-1  rounded-md"
            onClick={() => menuClickHandler(0, sidebaritems[0])}
          >
            {sidebaritems[0]?.title}
          </button>
        </div>
      )}
      <div className="flex gap-2">
        {sidebaritems.slice(1).map((nav, index) => {
          const active = activeMenu === nav?.id;
          return (
            <div
              key={index}
              className={`flex-1 flex flex-col py-1 md:py-4 md:px-1 rounded-lg bg-neutral-20 shadow-xl  hover:bg-primary-40 cursor-pointer items-center ${
                active && " bg-primary-20 "
              }`}
              onClick={() => menuClickHandler(nav?.id, nav)}
              aria-expanded={active}
              aria-controls={`submenu-${index}`}
            >
              <div className="flex flex-col gap-1 md:gap-2 items-center">
                {nav?.icon ? <img width={20} height={20} src={nav?.icon} alt="*" /> : null}
                <p className="text-[10px]"> {nav?.title}</p>
              </div>
              {type === "user" && index === 0 && (
                <p className=" text-title-sm-regular max-w-[200px] truncate ">
                  {userFirstName + " " + userLastName}
                </p>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BusninessMobileNavbarItems;
